"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletDetailsLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const access_1 = require("../../../../common/constants/access");
const userQuery_1 = require("../../../queries/userQuery");
const walletQuery_1 = require("../../../queries/walletQuery");
const zustandStore_1 = require("../../../zustandStore");
const logger = (0, pino_1.default)();
const walletDetailsLoader = async ({ queryClient, params, }) => {
    const verifyUserAccessQuery = (0, userQuery_1.getVerifyUserAccessQuery)(access_1.composites.WRITE_COMPANY);
    const userData = await queryClient.ensureQueryData(userQuery_1.userQuery);
    const hasAccess = await queryClient.ensureQueryData({
        queryKey: verifyUserAccessQuery.queryKey,
        queryFn: verifyUserAccessQuery.queryFn,
    });
    let walletData;
    if (params.virtualCardId) {
        try {
            walletData = await queryClient.ensureQueryData((0, walletQuery_1.virtualCardTask)(params.virtualCardId));
        }
        catch (error) {
            logger.error(error);
            walletData = undefined;
        }
    }
    else if (params.taskId) {
        try {
            walletData = await queryClient.ensureQueryData((0, walletQuery_1.walletDetailsQuery)(params.taskId));
        }
        catch (error) {
            logger.error(error);
            walletData = undefined;
        }
    }
    const isCardOwner = walletData?.context?.request?.requester?.userId === userData?.userId;
    zustandStore_1.useZustand.getState().setPageLoading(false);
    return {
        userData,
        hasAccess,
        requestTitle: walletData?.request?.title,
        isCardOwner,
    };
};
exports.walletDetailsLoader = walletDetailsLoader;
